/**
 * Valida CPF (formato e dígitos verificadores)
 */
export function limparCpf(cpf) {
  return String(cpf || '').replace(/\D/g, '')
}

export function validarCpf(cpf) {
  const numeros = limparCpf(cpf)
  if (numeros.length !== 11) return false
  if (/^(\d)\1{10}$/.test(numeros)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(numeros[i]) * (10 - i)
  let resto = (soma * 10) % 11
  if (resto === 10) resto = 0
  if (resto !== parseInt(numeros[9])) return false
  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(numeros[i]) * (11 - i)
  resto = (soma * 10) % 11
  if (resto === 10) resto = 0
  return resto === parseInt(numeros[10])
}
